import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Box, Button, FormField, Select, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiFilterMenuOutline, mdiFilterMultiple, mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import DRPicker from '../../../../../components/DRPicker';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelFlight from '../../../../../components/extras/SidePanelFlight';
import SelectCategory from '../../../../../components/selects/selectCategory';
import SelectFlightType from '../../../../../components/selects/selectFlightTypes';
import SelectGroupType from '../../../../../components/selects/selectGroupType';
import SelectUser from '../../../../../components/selects/selectUser';
import TableFlights from '../../../../../components/tables/tableFlights';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemFlight, ItemUser, pilotTypes } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, exportToExcel, getCookie, getUrlVersion, minutesToHHMM2, setData, setLoading, setParameters } from '../../../../commons/functions';

export const EDVInstructionFlightLogsPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")


    const { navigate } = useRouter();
    const { data, parameters, menu } = useGlobalState();
    const [flights, setFlights] = useState<ItemFlight[]>([]);
    const [flight, setFlight] = useState<ItemFlight>();
    const [userCount, setUserCount] = useState<number>(0);
    const [advanceFilter, setAdvanceFilter] = useState<boolean>(false);
    const [currentPageIndex, setCurrentPageIndex] = useState(1);

    const paginated = flights.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);

    useEffect(() => {
        if (parameters.startDate && parameters.endDate && parameters.pilotType && parameters.groupTypeMasterCode) {
            //handleFlightsSearch()
        }
    }, [parameters.startDate, parameters.endDate, parameters.pilotType, parameters.groupTypeMasterCode, parameters.idCategories, parameters.idGroupTypes, parameters.idFlightTypes, parameters.idUser]);

    const handleExcel = () => {
        let cumulativeDelta = 0;

        const flightsData = flights.map(flight => {
            cumulativeDelta += flight.delta ?? 0;
            return {
                Fecha: flight.departureDate,
                Material: flight.groupTypeMaster,
                Matrícula: flight.registration,
                Piloto: flight.userPilot,
                Instructor: flight.userInstructor || '',
                Tipo: flight.flightType,
                Duración: minutesToHHMM2(flight.delta ?? 0),
                Acumulado: minutesToHHMM2(cumulativeDelta),
            };
        });
        exportToExcel(flightsData, `bitacora_vuelos_${parameters.startDate}_a_${parameters.endDate}.xlsx`);
    }
    const handleFlightsSearch = async () => {
        try {
            setLoading(true)
            let body: any = {
                startDate: parameters.startDate,
                endDate: parameters.endDate,
                pilotType: parameters.pilotType ? parameters.pilotType : '',
                orderBy: "departureDate",
                order: "desc",
            }
            if (parameters.groupTypeMasterCode && parameters.groupTypeMasterCode.value != '') {
                //body = { ...body, groupTypeMasterCode: parameters.groupTypeMasterCode.value }
            }
            if (parameters.idUser && parameters.idUser > 0) {
                body = { ...body, idUser: parameters.idUser }
            }
            if (parameters.idCategories && parameters.idCategories.length > 0) {
                body = { ...body, idCategories: parameters.idCategories }
            }
            if (parameters.idGroupTypes && parameters.idGroupTypes.length > 0) {
                body = { ...body, idGroupTypes: parameters.idGroupTypes }
            }
            if (parameters.idFlightTypes && parameters.idFlightTypes.length > 0) {
                body = { ...body, idFlightTypes: parameters.idFlightTypes }
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setFlights(data.flights);
                setFlight(undefined)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            console.error("Error de red y/o comunicaciones:", error);
        } finally { setLoading(false) }
    }
    const totalFilters = parameters.idCategories?.length + parameters.idGroupTypes?.length + parameters.idFlightTypes?.length;

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            splitPanel={
                <SidePanelFlight flight={flight} />
            }
            splitPanelOpen={!!flight}
            onSplitPanelToggle={({ detail }) => !detail.open ? setFlight(undefined) : null}
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Bitácora de vuelos</Header>
                    <SpaceBetween direction="horizontal" size="xs">
                        <Box textAlign='left'>
                            <SpaceBetween direction="vertical" size="xs">
                                <SpaceBetween direction="horizontal" size="xs">
                                    <FormField label="Usuario">
                                        <SelectUser onConfirm={(user: ItemUser | undefined) => {
                                            if (user)
                                                setParameters({ ...parameters, idUser: user.idUser });
                                            else
                                                setParameters({ ...parameters, idUser: 0 });
                                        }}
                                            value={parameters.idUser}
                                        />
                                    </FormField>

                                    <FormField label="Al mando">
                                        <Select
                                            selectedOption={pilotTypes.find(opt => opt.value === parameters.pilotType) || { value: 'PILOT', label: 'Piloto' }}
                                            onChange={(e) => {
                                                setParameters({ ...parameters, pilotType: e.detail.selectedOption.value });
                                            }}
                                            options={pilotTypes}
                                        />
                                    </FormField>
                                    <FormField label="Rango de fechas">
                                        <DRPicker
                                            start={parameters.startDate || ''}
                                            end={parameters.endDate || ''}

                                            onConfirm={(start: string, end: string) => {
                                                setParameters({ ...parameters, startDate: start, endDate: end });

                                            }}
                                        />
                                    </FormField>
                                    <FormField label="&nbsp;">
                                        <Button style={{ root: btnIconForm }} onClick={() => setAdvanceFilter(!advanceFilter)}>
                                            <SpaceBetween direction="horizontal" size="xs">
                                                {advanceFilter ? <Icon path={mdiFilterMultiple} size={1} /> : <Icon path={mdiFilterMenuOutline} size={1} />}
                                                {totalFilters > 0 ? totalFilters : null}
                                            </SpaceBetween>
                                        </Button>
                                    </FormField>
                                    <FormField label="&nbsp;">
                                        <SpaceBetween direction="horizontal" size="xs">

                                            <Button style={{ root: btnIconForm }} onClick={() => handleFlightsSearch()}><Icon path={mdiMagnify} size={1} /></Button>
                                        </SpaceBetween>
                                    </FormField>

                                </SpaceBetween>
                                {advanceFilter && (
                                    <SpaceBetween direction="vertical" size="xs">
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <FormField label="Categoría">
                                                <SelectCategory single={false} onSelect={(idCategories) => {
                                                    setParameters({ ...parameters, idCategories: idCategories });
                                                }} value={parameters.idCategories} hideTokens={false} tokenLimit={0}
                                                />
                                            </FormField>

                                            <FormField label="Grupo">
                                                <SelectGroupType single={false} onSelect={(idGroupTypes) => {
                                                    setParameters({ ...parameters, idGroupTypes: idGroupTypes });
                                                }} value={parameters.idGroupTypes} hideTokens={false} tokenLimit={0}
                                                />
                                            </FormField>
                                            <FormField label="Tipo de vuelo">
                                                <SelectFlightType single={false} onSelect={(idFlightTypes) => {
                                                    setParameters({ ...parameters, idFlightTypes: idFlightTypes });
                                                }} value={parameters.idFlightTypes} hideTokens={false} tokenLimit={0}
                                                    dataset={data.bookingTypes}
                                                />
                                            </FormField>
                                        </SpaceBetween>
                                    </SpaceBetween>
                                )}
                            </SpaceBetween>
                        </Box>
                    </SpaceBetween >
                    <TableFlights flights={flights} onSelect={(fl: ItemFlight) => setFlight(fl)} excel />


                </SpaceBetween >
            }
        />
    )
};

